import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=472f9d4a&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472f9d4a')) {
      api.createRecord('472f9d4a', component.options)
    } else {
      api.reload('472f9d4a', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=472f9d4a&", function () {
      api.rerender('472f9d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20PG6paUVJ6g1/JS/comp/pricelist.vue"
export default component.exports